import { render, staticRenderFns } from "./AppEmptyState.vue?vue&type=template&id=678b5e0f"
import script from "./AppEmptyState.vue?vue&type=script&lang=js"
export * from "./AppEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports